import dashboard from "./dashboardPT.json";
import orderSummary from "./orderSummaryPT.json";

export const dashboardPT = {
	dashboard,
	orderSummary,
};
